import { Language, Translations } from '../types/language';

export const translations: Record<Language, Translations> = {
  ko: {
    predefinedQuestions: [
      '공공시설 이용시간\n조회',
      '도서관 도서 조회',
      '여민전 가맹점 조회',
      '영업허가 입지점검 서비스\n(장사명당)',
      '생활불편 신고',
      '세종시 아파트\n공시가격 조회',
      // '맛집 • 관광 정보',
    ],
    hoverMessages: [
      '통합예약시스템 공공시설 이용시간 조회 가능여부를 알려드립니다. \n이용시간 관련 질문을 할 때는 날짜와 시설물(축구장, 야구장 등), 읍면동(나성동, 장군면 등)을 명확하게 입력해주세요. \n(질문예시: 해밀동 배드민턴장 오늘 예약 가능한 시간이 있나요?)',
      '도서관 도서 보유 현황을 알려드립니다. \n도서 관련 질문을 할 때는 해당 도서관명(세종시립도서관, 보람동 도서관 등)과 도서명 또는 작가명을 명확하게 입력해주세요. \n(질문예시: 시립도서관에 세종대왕 책 있나요?, 시립도서관에 한강 작가 책 알려주세요)',
      // '무인 민원 발급기 위치 정보를 알려드립니다. \n(질문예시: 세종시 무인 민원 발급기는 어디에 있나요?)',
      '상호명으로 여민전 가능여부를 알려드립니다.\n가맹점명은 **한국어 상호**로 입력해 주세요.\n(질문예시: 신흥파닭은 여민전 되나요?)',
      '영업허가 가능여부를 알려드립니다. \n영업허가 관련 질문을 할 때는 주소(지번, 도로명 등)와 업종(제과점, 학원 등)을 명확하게 입력해주세요. \n(질문예시: 보람동 715 일반음식점 입지점검 해주세요) \n(안내: 카드를 누르면 입지점검 전용 페이지로 이동합니다.)',
      '생활 불편 관련 정보를 알려드립니다.',
      '세종시 아파트 공시가격 정보를 알려드립니다. \n읍면동, 아파트 이름, 동, 호수를 명확하게 입력해주세요. \n(질문예시: 한솔동 힐스테이트 O동 O호 공시가격 알려주세요, 수루배마을6단지 O동 O호 공시가격은 얼마인가요?)',
      // '지역상권 및 관광문화 활성화를 위해 SNS 내 다양한 세종시 맛집 • 관광 정보를 수집하여 알려드립니다. \n해당정보는 세종시 공식자료가 아니며, 법적 책임을 지지 않습니다. \n(질문예시: 이응다리 인근 뷰 맛집은)'
    ],
    menuItems: [
      {
        label: '행정일반',
        items: [
          '담당자 전화번호',
          '여권 발급처',
          '무료 법률상담',
          '문자안내 서비스',
          '세종소식 (SNS)',
          '고향사랑기부제',
          '일자리지원센터',
          '기업민원해결센터',
          // '주민자치프로그램',
          '시민안심보험',
          '민원 신청',
          '최신 재난정보',
        ],
      },
      {
        label: '문화 관광',
        items: [
          // '이번주 문화행사',
          '세종 관광명소',
          '세종축제',
          '조치원복숭아축제',
          '낙화축제',
          // '빛축제',
          '시티투어',
          '관광안내 책자 신청',
          '캠핑장 안내',
          // '둘레길 안내',
          // '자전거길 안내',
        ],
      },
      {
        label: '생활 정보',
        items: [
          '지역화폐 여민전',
          '이응패스',
          '통합예약시스템 안내',
          '공공자전거 어울링',
          '시티앱',
          // '세종엔',
          '도서관 현황',
          '수영장 현황',
        ],
      },
      {
        label: '교통 차량',
        items: [
          '버스노선 안내',
          '자동차 등록',
          '불법 주정차 안내',
          '장애인 전용 주차구역 위반',
          '도로파손 신고',
          '신호등 불편신고',
        ],
      },
      {
        label: '보건 복지',
        items: [
          '보건소 안내',
          '보건증 신청서류',
          '보건증 발급 수수료',
          '당직병원 및 약국정보',
          '세종시 출산정책',
          '청소년센터',
          '기초연금 신청',
        ],
      },
      {
        label: '세정',
        items: [
          '개별 주택 가격안내',
          '공동 주택 가격안내',
          '건축물 시가표준액 안내',
          '자동차세 부과기준',
          '지방세 전자고지 신청',
        ],
      },
      {
        label: '환경',
        items: [
          '크린넷 고장 신고',
          '로드킬 (동물사체) 처리',
          '대형폐기물 배출방법',
          '쓰레기 종량제 봉투 가격',
          '수도 요금 조회',
          '환경개선부담금',
          '노후경유차 조기폐차 지원사업',
        ],
      },
      {
        label: '챗봇 도움말',
        items: [
          '챗봇 이용 가이드',
        ],
      },
      {
        label: '챗봇 공지사항',
        items: [],
      },
      {
        label: '관련 누리집 링크',
        items: [
          '대표누리집',
          '통합예약시스템',
          '도서관 누리집',
          '부동산 공시가격 알리미',
        ],
      },
    ],
    chatInput: {
      placeholder: '대화하듯이 질문해주세요.',
      voiceRecording: '음성 녹음',
      voiceLevel: '음성 레벨',
      stopRecording: '녹음 중지',
      listenMessage: '말씀해 주세요... (무음 감지 중)',
      recordingMessage: '음성을 녹음하고 있습니다...',
      sendMessage: '메시지 전송',
      stopSending: '전송 중지',
      resetChat: '대화 초기화',
      openPredefinedQuestions: '추천 질문 보기',
    },
    chatWindow: {
      searching: '관련 정보를 검색하는 중입니다',
      generating: '응답을 생성 중입니다',
      playTTS: '🔊 음성으로 듣기',
      stopTTS: '⏹️ 재생 중지',
      department: '담당부서',
      phone: '전화번호',
      name: '이름',
      email: '이메일',
      relatedSite: '관련사이트 링크',
      feedbackPlaceholder: '피드백은 AI를 나아가게 하는 힘이됩니다.',
      submit: '제출',
      loadingMessages: [
        '잠시만 기다려주세요',
        '관련 정보를 검색하는 중입니다',
        '내용을 분석하는 중입니다',
        '응답을 생성하는 중입니다'
      ],
      likeAnswer: '답변 좋아요',
      dislikeAnswer: '답변 싫어요',
      openFeedback: '피드백 작성',
    },
    intro: {
      title: '알려드립니다!',
      description:
        'AI충녕은 생성형 인공지능 머신이 세종시 관련 데이터를 스스로 학습하여 답변을 제공해주는 시스템입니다.',
      disclaimer:
        'AI알고리즘 특성상 오류가 발생할 수 있으므로 중요사항은 안내된 담당부서에 확인 부탁드립니다.',
      dontShowToday: '오늘 다시보지 않기',
    },
    common: {
      welcomeTagline: '누구나 쉽게 익혀 날로 씀에 편안케 하소서',
      welcomeTitle: '궁금한 건 제가 찾아드릴게요!',
      noHoverMessage: '안내 메시지가 없습니다.',
      requestData: '기능개선 요청',
      confirm: '확인',
      userGuideTitle: '사용 가이드',
      openPermitPage: '입지점검 서비스(장사명당) 페이지로 이동',
      openMenu: '메뉴 열기',
      closeMenu: '메뉴 닫기',
      selectLanguage: '언어 선택',
      enableDarkMode: '다크 모드 켜기',
      disableDarkMode: '다크 모드 끄기',
      closeGuide: '가이드 닫기',
    },
    sidebar: {
      mainPhone: '대표전화: 044-120',
      weekdayHours: '평일 08:30 ~ 18:30',
      weekendHours: '토공휴일 09:00 ~ 18:00',
      afterHours: '근무시간 외 당직실 연결',
    },
    statusBar: {
      sejongWeather: '세종날씨',
      fineDust: '미세먼지',
      passportQueue: '여권신청 대기인원',
      people: '명',
      todayDate: '오늘 날짜',
      currentTemp: '현재 세종시 기온',
      airQuality: '미세먼지',
      dateFormat: '{month}월 {day}일',
      aqiRatings: {
        good: '좋음',
        normal: '보통',
        bad: '나쁨',
        veryBad: '매우나쁨',
        noData: '데이터없음'
      }
    },
  },
  en: {
    predefinedQuestions: [
      'Public facility\nhours inquiry',
      'Library book inquiry',
      'Yeominjeon stores inquiry',
      'Business permit\nlocation check',
      'Department location guidance',
      'Sejong apartment\nofficial price inquiry',
    ],
    hoverMessages: [
      'You can inquire about the availability of public facility usage times via the unified reservation system. Please enter date and facilities (e.g., soccer field, baseball field) and region names (e.g., Naseong-dong, Janggun-myeon) clearly when asking questions about usage times.\n(Example: Are there available times to reserve the Haemil-dong badminton court today?)',
      'Provide information on library book availability. When asking about books, please enter the library name (e.g., Sejong City Library, Boram-dong Library) and book title or author name clearly.\n(Example: Does the City Library have books about King Sejong?, Please tell me about books by author Han Kang at the City Library)',
      'Check Yeominjeon acceptance by store name.\n**Store names must be in Korean** for lookup (e.g. 신흥파닭).\n(Example: Can I use Yeominjeon at 신흥파닭?)',
      'We provide information on business permit eligibility.\nWhen asking about business permits, please clearly enter the address (lot number, street address, etc.) and business type (e.g., bakery, academy).\n(Example: Please check business permit eligibility for a general restaurant at Boram-dong 715.)\n(Note: Click the card to open the dedicated location check page.)',
      'Provide location information for departments within the office.\n(Example: Where is the briefing room of Sejong City Hall?)',
      'Provide information on Sejong apartment official land prices. Please enter region, apartment name, building, and unit number clearly.\n(Example: Please tell me the official land price for Hillstate in Hansol-dong, Building O, Unit O; what is the official land price for Surubai Village 6 Complex, Building O, Unit O?)',
    ],
    menuItems: [
      {
        label: 'General Administration',
        items: [
          'Contact Phone Number',
          'Passport Issuance Office',
          'Free Legal Consultation',
          'Text Notification Service',
          'Sejong News (SNS)',
          'Hometown Love Donation System',
          'Job Support Center',
          'Corporate Complaint Resolution Center',
          // 'Resident Autonomy Program',
          'Citizen Safety Insurance',
          'Civil Complaint Application',
          'Latest Disaster Information',
        ],
      },
      {
        label: 'Culture & Tourism',
        items: [
          // 'This Week\'s Cultural Events',
          'Sejong Tourist Attractions',
          'Sejong Festival',
          'Jochiwon Peach Festival',
          'Nakhwa Festival',
          'Light Festival',
          'City Tour',
          'Tourism Guide Booklet Application',
          'Camping Site Information',
          // 'Trail Information',
          // 'Bicycle Path Information',
        ],
      },
      {
        label: 'Living Information',
        items: [
          'Regional Currency Yeomin',
          'Eung Pass',
          'Integrated Reservation System Guide',
          'Public Bicycle Eoulling',
          'City App',
          // 'Sejong N',
          'Library Status',
          'Swimming Pool Status',
        ],
      },
      {
        label: 'Transportation & Vehicles',
        items: [
          'Bus Route Information',
          'Vehicle Registration',
          'Illegal Parking Information',
          'Disabled Parking Zone Violation',
          'Road Damage Report',
          'Traffic Light Complaint',
        ],
      },
      {
        label: 'Health & Welfare',
        items: [
          'Public Health Center Information',
          'Health Certificate Application Documents',
          'Health Certificate Issuance Fee',
          'Emergency Hospital & Pharmacy Information',
          'Sejong City Birth Policy',
          'Youth Center',
          'Basic Pension Application',
        ],
      },
      {
        label: 'Tax Administration',
        items: [
          'Individual Housing Price Information',
          'Common Housing Price Information',
          'Building Standard Price Information',
          'Automobile Tax Assessment Criteria',
          'Local Tax Electronic Notice Application',
        ],
      },
      {
        label: 'Environment',
        items: [
          'Clean Net Malfunction Report',
          'Roadkill (Animal Carcass) Processing',
          'Large Waste Disposal Method',
          'Garbage Volume-based Bag Price',
          'Water Bill Inquiry',
          'Environmental Improvement Charge',
          'Old Diesel Vehicle Early Scrapping Support',
        ],
      },
      {
        label: 'Chatbot Help',
        items: [
          'Chatbot User Guide',
        ],
      },
      {
        label: 'Chatbot Notices',
        items: [],
      },
      {
        label: 'Related Website Links',
        items: [
          'Official Website',
          'Integrated Reservation System',
          'Library Website',
          'Official Land Price Notice',
        ],
      },
    ],
    chatInput: {
      placeholder: 'Please ask me a question naturally.',
      voiceRecording: 'Voice Recording',
      voiceLevel: 'Voice Level',
      stopRecording: 'Stop Recording',
      listenMessage: 'Please speak... (Detecting silence)',
      recordingMessage: 'Recording your voice...',
      sendMessage: 'Send message',
      stopSending: 'Stop sending',
      resetChat: 'Reset conversation',
      openPredefinedQuestions: 'Show suggested questions',
    },
    chatWindow: {
      searching: 'Searching for relevant information',
      generating: 'Generating response',
      playTTS: '🔊 Listen with Voice',
      stopTTS: '⏹️ Stop Playback',
      department: 'Department',
      phone: 'Phone',
      name: 'Name',
      email: 'Email',
      relatedSite: 'Related Site Link',
      feedbackPlaceholder: 'Feedback helps AI improve.',
      submit: 'Submit',
      loadingMessages: [
        'Please wait a moment',
        'Searching for relevant information',
        'Analyzing content',
        'Generating response'
      ],
      likeAnswer: 'Like this answer',
      dislikeAnswer: 'Dislike this answer',
      openFeedback: 'Write feedback',
    },
    intro: {
      title: 'Notice',
      description:
        'AI Chungnyeong is a system where a generative AI learns Sejong City data and provides answers.',
      disclaimer:
        'Due to the nature of AI algorithms, errors may occur. Please verify important matters with the relevant department.',
      dontShowToday: "Don't show again today",
    },
    common: {
      welcomeTagline: 'Easy for everyone to learn, comfortable for daily use',
      welcomeTitle: 'How can I help you?',
      noHoverMessage: 'No guidance message available.',
      requestData: 'Request Data',
      confirm: 'OK',
      userGuideTitle: 'User Guide',
      openPermitPage: 'Open location check page',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      selectLanguage: 'Select language',
      enableDarkMode: 'Enable dark mode',
      disableDarkMode: 'Disable dark mode',
      closeGuide: 'Close guide',
    },
    sidebar: {
      mainPhone: 'Main Phone: 044-120',
      weekdayHours: 'Weekdays 08:30 ~ 18:30',
      weekendHours: 'Sat/Holidays 09:00 ~ 18:00',
      afterHours: 'After-hours duty office connection',
    },
    statusBar: {
      sejongWeather: 'Sejong Weather',
      fineDust: 'Fine Dust',
      passportQueue: 'Passport Application Queue',
      people: 'people',
      todayDate: 'Today Date',
      currentTemp: 'Current Temperature',
      airQuality: 'Air Quality',
      dateFormat: '{month}/{day}',
      aqiRatings: {
        good: 'Good',
        normal: 'Normal',
        bad: 'Bad',
        veryBad: 'Very Bad',
        noData: 'No Data'
      }
    },
  },
  ja: {
    predefinedQuestions: [
      '公共施設の利用時間\n照会',
      '図書館の図書照会',
      'ヨミンジョン加盟店の検索',
      '営業許可立地検査',
      '部署の場所案内',
      '世宗市アパート\n公示地価照会',
    ],
    hoverMessages: [
      '統合予約システムを通じて公共施設の利用時間の利用可能性をお知らせします。利用時間に関する質問をするときは、日付と施設（例：サッカー場、野球場）および地域名（例：羅城洞、長軍面）を明確に入力してください。\n（例：海密洞バドミントン場は今日予約可能な時間がありますか？）',
      '図書館の図書所蔵状況をお知らせします。図書に関する質問をするときは、該当図書館名（世宗市立図書館、ボラム洞図書館など）と図書名または著者名を明確に入力してください。\n（例：市立図書館に世宗大王の本はありますか？、市立図書館にハンガン著者の本を教えてください）',
      '店舗名でヨミンジョンの利用可否をお知らせします。\n**店舗名は韓国語表記**で入力してください（例：신흥파닭）。\n（例：신흥파닭でヨミンジョンは使えますか？）',
      '営業許可の可否をお知らせします。\n営業許可に関する質問では、住所（地番、道路名など）と業種（例：製菓店、学원）を明確に入力してください。\n（例：ボラム洞715一般飲食店の立地検査をお願いします）\n（案内：カードを押すと立地検査専用ページが開きます）',
      '事務所内の部門の位置情報を提供します。\n（例：世宗市役所のブリーフィングルームはどこですか？）',
      '世宗市アパートの公示地価情報をお知らせします。邑面洞、アパート名、棟、号数を明確に入力してください。\n（例：ハンソル洞ヒルステートO棟O号の公示地価を教えてください、スルベマウル6団地O棟O号の公示地価はいくらですか？）',
    ],
    menuItems: [
      {
        label: '行政一般',
        items: [
          '担当者電話番号',
          'パスポート発給所',
          '無料法律相談',
          '文字案内サービス',
          '世宗ニュース (SNS)',
          '故郷愛寄付制',
          '就職支援センター',
          '企業民願解決センター',
          // '住民自治プログラム',
          '市民安心保険',
          '民願申請',
          '最新災害情報',
        ],
      },
      {
        label: '文化観光',
        items: [
          // '今週の文化行事',
          '世宗観光名所',
          '世宗祭り',
          'チョチウォン桃祭り',
          'ナクファ祭り',
          '光祭り',
          'シティツアー',
          '観光案内冊子申請',
          'キャンプ場案内',
          // '周回路案内',
          // '自転車道案内',
        ],
      },
      {
        label: '生活情報',
        items: [
          '地域通貨リョミンジョン',
          'イウンパス',
          '統合予約システム案内',
          '公共自転車オウルリン',
          'シティアプリ',
          // '世宗N',
          '図書館現況',
          'プール現況',
        ],
      },
      {
        label: '交通車両',
        items: [
          'バス路線案内',
          '自動車登録',
          '違法駐車案内',
          '障害者専用駐車区域違反',
          '道路破損届出',
          '信号機不便届出',
        ],
      },
      {
        label: '保健福祉',
        items: [
          '保健所案内',
          '保健証申請書類',
          '保健証発給手数料',
          '当直病院・薬局情報',
          '世宗市出産政策',
          '青少年センター',
          '基礎年金申請',
        ],
      },
      {
        label: '税政',
        items: [
          '個別住宅価格案内',
          '共通住宅価格案内',
          '建築物時価標準額案内',
          '自動車税賦課基準',
          '地方税電子告知申請',
        ],
      },
      {
        label: '環境',
        items: [
          'クリーンネット故障届出',
          'ロードキル（動物死体）処理',
          '大型廃棄物排出方法',
          'ゴミ従量制袋価格',
          '水道料金照会',
          '環境改善負担金',
          '老朽ディーゼル車早期廃車支援事業',
        ],
      },
      {
        label: 'チャットボットヘルプ',
        items: [
          'チャットボット利用ガイド',
        ],
      },
      {
        label: 'チャットボットお知らせ',
        items: [],
      },
      {
        label: '関連ウェブサイトリンク',
        items: [
          '代表ホームページ',
          '統合予約システム',
          '図書館ホームページ',
          '不動産公示価格通知',
        ],
      },
    ],
    chatInput: {
      placeholder: '会話するように質問してください。',
      voiceRecording: '音声録音',
      voiceLevel: '音声レベル',
      stopRecording: '録音停止',
      listenMessage: 'お話しください...（無音検出中）',
      recordingMessage: '音声を録音しています...',
      sendMessage: 'メッセージを送信',
      stopSending: '送信を停止',
      resetChat: '会話をリセット',
      openPredefinedQuestions: 'おすすめ質問を表示',
    },
    chatWindow: {
      searching: '関連情報を検索しています',
      generating: '応答を生成中です',
      playTTS: '🔊 音声で聞く',
      stopTTS: '⏹️ 再生停止',
      department: '担当部署',
      phone: '電話番号',
      name: '氏名',
      email: 'メール',
      relatedSite: '関連サイトリンク',
      feedbackPlaceholder: 'フィードバックはAIを向上させる力になります。',
      submit: '提出',
      loadingMessages: [
        'しばらくお待ちください',
        '関連情報を検索しています',
        '内容を分析しています',
        '応答を生成しています'
      ],
      likeAnswer: '回答にいいね',
      dislikeAnswer: '回答に低評価',
      openFeedback: 'フィードバックを書く',
    },
    intro: {
      title: 'お知らせ',
      description:
        'AI忠寧は、生成型人工知能が世宗市関連データを学習し、回答を提供するシステムです。',
      disclaimer:
        'AIアルゴリズムの特性上、誤りが生じる場合があります。重要事項は担当部署にご確認ください。',
      dontShowToday: '今日は再表示しない',
    },
    common: {
      welcomeTagline: 'どなたでも気軽に、日々の暮らしに寄り添うように',
      welcomeTitle: '何をお手伝いできますか？',
      noHoverMessage: 'ガイダンスメッセージがありません。',
      requestData: '資料請求',
      confirm: '確認',
      userGuideTitle: '利用ガイド',
      openPermitPage: '立地検査ページへ移動',
      openMenu: 'メニューを開く',
      closeMenu: 'メニューを閉じる',
      selectLanguage: '言語を選択',
      enableDarkMode: 'ダークモードをオン',
      disableDarkMode: 'ダークモードをオフ',
      closeGuide: 'ガイドを閉じる',
    },
    sidebar: {
      mainPhone: '代表電話: 044-120',
      weekdayHours: '平日 08:30 ~ 18:30',
      weekendHours: '土祝日 09:00 ~ 18:00',
      afterHours: '勤務時間外当直室接続',
    },
    statusBar: {
      sejongWeather: '世宗天気',
      fineDust: '微細粉塵',
      passportQueue: 'パスポート申請待機人員',
      people: '名',
      todayDate: '今日の日付',
      currentTemp: '現在の気温',
      airQuality: '大気質',
      dateFormat: '{month}月{day}日',
      aqiRatings: {
        good: '良好',
        normal: '普通',
        bad: '悪い',
        veryBad: '非常に悪い',
        noData: 'データなし'
      }
    },
  },
  cn: {
    predefinedQuestions: [
      '公共设施\n使用时间查询',
      '图书馆图书查询',
      '余民钱加盟店查询',
      '营业许可立地检查',
      '部门位置指南',
      '世宗市公寓\n公示地价查询',
    ],
    hoverMessages: [
      '通过综合预约系统告知公共设施使用时间的可用情况。询问使用时间时，请清楚输入日期和设施（如足球场、棒球场）以及地区名称（如罗城洞、长军面）。\n（示例：海密洞羽毛球场今天有可预约的时间吗？）',
      '告知图书馆图书馆藏情况。询问图书时，请清楚输入图书馆名称（如世宗市立图书馆、保蓝洞图书馆）和书名或作者名。\n（示例：市立图书馆有世宗大王的书吗？请告诉我市立图书馆韩江作家的书）',
      '按店名查询是否可使用余民钱。\n**店名请使用韩语**（如：신흥파닭）。\n（示例：신흥파닭可以使用余民钱吗？）',
      '告知营业许可可否。\n营业许可相关提问时，请清楚输入地址（地号、道路名等）和业种（如糕点店、学院）。\n（示例：请帮我做保蓝洞715一般饮食店立地检查）\n（说明：点击卡片将打开立地检查专用页面）',
      '提供厅内科室的位置信息。\n（示例：世宗市政厅的简报室在哪里？）',
      '告知世宗市公寓公示地价信息。请清楚输入邑面洞、公寓名称、栋、户号。\n（示例：请告诉我韩松洞Hillstate O栋O号的公示地价，水鲁背村6小区O栋O号的公示地价是多少？）',
    ],
    menuItems: [
      {
        label: '行政一般',
        items: [
          '负责人电话号码',
          '护照发放处',
          '免费法律咨询',
          '短信通知服务',
          '世宗消息 (SNS)',
          '故乡爱心捐赠制',
          '就业支援中心',
          '企业民愿解决中心',
          // '居民自治程序',
          '市民安心保险',
          '民愿申请',
          '最新灾害信息',
        ],
      },
      {
        label: '文化观光',
        items: [
          // '本周文化活动',
          '世宗观光名胜',
          '世宗庆典',
          '鸟致院桃花节',
          '落花节',
          '灯光节',
          '城市游览',
          '观光指南册子申请',
          '露营场指南',
          // '环路指南',
          // '自行车道指南',
        ],
      },
      {
        label: '生活信息',
        items: [
          '地区货币如民钱',
          '毅应通行证',
          '综合预约系统指南',
          '公共自行车和谐铃',
          '城市应用',
          // '世宗N',
          '图书馆现状',
          '游泳池现状',
        ],
      },
      {
        label: '交通车辆',
        items: [
          '公交线路指南',
          '汽车登记',
          '违法停车指南',
          '残疾人专用停车区违规',
          '道路损坏举报',
          '信号灯不便举报',
        ],
      },
      {
        label: '保健福利',
        items: [
          '保健所指南',
          '健康证申请资料',
          '健康证发放手续费',
          '值班医院及药局信息',
          '世宗市生育政策',
          '青少年中心',
          '基础养老金申请',
        ],
      },
      {
        label: '税政',
        items: [
          '个别住宅价格指南',
          '公共住宅价格指南',
          '建筑物市价标准额指南',
          '汽车税征收标准',
          '地方税电子告知申请',
        ],
      },
      {
        label: '环境',
        items: [
          'Clean Net故障举报',
          '动物尸体处理',
          '大型废弃物排放方法',
          '垃圾计量制袋子价格',
          '自来水费用查询',
          '环境改善负担金',
          '老旧柴油车提前报废支援事业',
        ],
      },
      {
        label: '聊天机器人帮助',
        items: [
          '聊天机器人使用指南',
        ],
      },
      {
        label: '聊天机器人公告',
        items: [],
      },
      {
        label: '相关网站链接',
        items: [
          '代表网站',
          '综合预约系统',
          '图书馆网站',
          '房地产公示价格通知',
        ],
      },
    ],
    chatInput: {
      placeholder: '请像对话一样提问。',
      voiceRecording: '语音录音',
      voiceLevel: '语音级别',
      stopRecording: '停止录音',
      listenMessage: '请说话...（检测静音中）',
      recordingMessage: '正在录制您的语音...',
      sendMessage: '发送消息',
      stopSending: '停止发送',
      resetChat: '重置对话',
      openPredefinedQuestions: '显示推荐问题',
    },
    chatWindow: {
      searching: '正在搜索相关信息',
      generating: '正在生成回复',
      playTTS: '🔊 语音播放',
      stopTTS: '⏹️ 停止播放',
      department: '负责部门',
      phone: '电话号码',
      name: '姓名',
      email: '电子邮件',
      relatedSite: '相关网站链接',
      feedbackPlaceholder: '反馈是让AI进步的力量。',
      submit: '提交',
      loadingMessages: [
        '请稍等片刻',
        '正在搜索相关信息',
        '正在分析内容',
        '正在生成回复'
      ],
      likeAnswer: '赞这个回答',
      dislikeAnswer: '踩这个回答',
      openFeedback: '撰写反馈',
    },
    intro: {
      title: '温馨提示',
      description:
        'AI忠宁是由生成式人工智能学习世宗市相关数据并提供回答的系统。',
      disclaimer:
        '由于AI算法特性，可能出现错误。重要事项请向相关部门确认。',
      dontShowToday: '今日不再显示',
    },
    common: {
      welcomeTagline: '人人易学，日用舒心',
      welcomeTitle: '有什么可以帮助您的吗？',
      noHoverMessage: '没有可用的指导信息。',
      requestData: '资料请求',
      confirm: '确认',
      userGuideTitle: '使用指南',
      openPermitPage: '进入立地检查页面',
      openMenu: '打开菜单',
      closeMenu: '关闭菜单',
      selectLanguage: '选择语言',
      enableDarkMode: '开启深色模式',
      disableDarkMode: '关闭深色模式',
      closeGuide: '关闭指南',
    },
    sidebar: {
      mainPhone: '代表电话: 044-120',
      weekdayHours: '工作日 08:30 ~ 18:30',
      weekendHours: '周六节假日 09:00 ~ 18:00',
      afterHours: '工作时间外值班室连接',
    },
    statusBar: {
      sejongWeather: '世宗天气',
      fineDust: '细颗粒物',
      passportQueue: '护照申请等待人员',
      people: '人',
      todayDate: '今天日期',
      currentTemp: '当前温度',
      airQuality: '空气质量',
      dateFormat: '{month}月{day}日',
      aqiRatings: {
        good: '良好',
        normal: '普通',
        bad: '不良',
        veryBad: '非常不良',
        noData: '无数据'
      }
    },
  },
};

export const getTranslation = (language: Language): Translations => {
  if (language && translations[language]) return translations[language];
  return translations.ko;
};
